module.exports = __webpack_public_path__ + "static/media/project5.a74522db.png";